var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8815 3.00328C10.6252 2.98688 10.3606 3.04347 10.1224 3.18297C9.48706 3.55563 9.27447 4.37315 9.64714 5.00849L10.8542 7.06838L6.94401 13.7416H3.83333C3.09733 13.7416 2.5 14.3389 2.5 15.0749C2.5 15.8109 3.09733 16.4082 3.83333 16.4082H14.1081C14.2127 15.8996 14.1488 15.3479 13.8555 14.8379L13.8529 14.8353C13.5949 14.386 13.237 14.0189 12.8203 13.7416H10.0352L15.1523 5.00718C15.5243 4.37185 15.3111 3.55497 14.6758 3.18297C14.0398 2.81097 13.2236 3.02419 12.8516 3.65953L12.3997 4.43036L11.9479 3.65953C11.715 3.26244 11.3086 3.0306 10.8815 3.00328ZM14.707 8.36916L14.1562 9.28453C13.5483 10.2952 13.5286 11.5461 14.0846 12.5788L18.2826 19.7429C18.5306 20.1669 18.9756 20.4017 19.4336 20.4017C19.6623 20.4017 19.8948 20.3434 20.1068 20.2194C20.7421 19.8474 20.9547 19.0305 20.582 18.3952L19.418 16.4082H21.1667C21.9027 16.4082 22.5 15.8109 22.5 15.0749C22.5 14.3389 21.9027 13.7416 21.1667 13.7416H17.8555L14.707 8.36916ZM5.58333 17.7442C5.212 17.7335 4.85115 17.7911 4.50781 17.8991L4.21094 18.4043C3.83827 19.039 4.05217 19.8565 4.6875 20.2285C4.8995 20.3532 5.13071 20.4121 5.35937 20.4121C5.81737 20.4121 6.26305 20.1753 6.51172 19.752L7.22917 18.528C6.83917 18.0727 6.26924 17.7642 5.58724 17.7442H5.58333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.1c60bbad69b8c0576cc6adfd60376fa7.svg";
export { ForwardRef as ReactComponent };